<template>
  <v-card flat="flat">
    <v-tabs
      v-model="tabPage"
      background-color="transparent"
      fixed-tabs
      slider-color="white"
      :vertical="verticalTabs"
    >
      <v-tab><v-icon left>web</v-icon>Webpage</v-tab>
      <v-tab><v-icon left>picture_as_pdf</v-icon>PDF</v-tab>
      <v-tab><v-icon left>photo</v-icon>IMAGE</v-tab>
      <!-- <v-tab><v-icon left>photo</v-icon>IMAGE</v-tab>
      <v-tab><v-icon left>insert_drive_file</v-icon>Drive</v-tab> -->
      <!-- <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn text class="align-self-center mr-4" v-on="on">
            more
            <v-icon right>arrow_drop_down</v-icon>
          </v-btn>
        </template>

        <v-list class="grey lighten-3">
          <v-list-item @click="">
            Email
          </v-list-item>
        </v-list>
      </v-menu> -->
      <v-tab-item class="px-4">
        <v-text-field
          v-model="url"
          :loading="loading"
          :disabled="loading"
          :messages="loading ? 'Fetching Webpage' : ''"
          :error-messages="errors.url"
          label="Webpage URL"
          placeholder="https://website.com"
          append-outer-icon="send"
          @click:append-outer="saveUrl"
          @keypress.enter="saveUrl"
        ></v-text-field>
      </v-tab-item>
      <v-tab-item class="px-4">
        <v-file-input
          :loading="loading"
          :disabled="loading"
          :messages="loading ? 'Uploading PDF' : ''"
          :error-messages="errors.pdf"
          append-outer-icon=""
          @click:append-outer=""
          accept="application/pdf"
          label="Select a PDF"
          @change="saveFile"
        ></v-file-input>
      </v-tab-item>
      <v-tab-item class="px-4">
        <img v-if="file && file.type.startsWith('image')" :src="preview" width="150" />
        <v-file-input
          accept="image/png, image/jpeg, image/bmp"
          prepend-icon="photo"
          show-size
          label="Select Image"
          :loading="loading"
          :disabled="loading"
          :messages="loading ? 'Uploading Image' : ''"
          :error-messages="errors.pdf"
          append-outer-icon="send"
          @click:append-outer="saveFile"
          @change="setupImage"
        ></v-file-input>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import generateThumb from '@/store/database/easyFirestore/utils/generateThumb';

export default {
  props: ['verticalTabs', 'flat'],
  data() {
    return {
      c: console,
      file: null,
      preview: null,
      thumbnail: null,
      url: null,
      tabPage: 0,
      loading: false,
      errors: {
        url: null,
        pdf: null
      }
    };
  },
  methods: {
    ...mapActions('resources', ['createNewResource']),
    generateThumb() {
      generateThumb(this.file)
        .then()
        .catch(e => console.log(e));
    },
    setupImage(file) {
      console.log(file);
      this.file = file;
      if (file) {
        this.preview = URL.createObjectURL(file);
        this.generateThumb();
      } else {
        URL.revokeObjectURL(this.preview);
        this.preview = null;
      }
    },
    saveFile(file) {
      this.file = file;
      const fileType = this.file.type.split('/')[0];
      const type = fileType == 'image' ? 'image' : 'pdf';
      this.loading = true;
      this.createNewResource({ type, file: this.file })
        .then(id => {
          this.$emit('created', id);
          this.loading = false;
          console.log(id);
          URL.revokeObjectURL(this.preview);
          this.preview = null;
        })
        .catch(e => {
          this.loading = false;
          this.errors.pdf = 'There was a problem uploading that file.';
          console.log(e);
        });
    },
    saveUrl() {
      this.loading = true;
      this.createNewResource({ type: 'webpage', url: this.url })
        .then(id => {
          this.$emit('created', id);
          this.loading = false;
          console.log(id);
        })
        .catch(e => {
          this.loading = false;
          this.errors.url = 'There was a problem capturing that URL.';
          console.log(e);
        });
    }
  }
};
</script>

<style></style>
